import { Box, Center, Spinner } from '@chakra-ui/react';
import { DITable } from 'plugins/DITable';
import TablePagination from 'plugins/DITable/Pagination';
import useSalesData from './useSalesData';
import SalesDataToolbar from './Toolbar';

const SalesDataTab = () => {
    const {
        table,
        isSalesDataLoading,

    } = useSalesData();
    return (
        <Box mt="16px">
            <SalesDataToolbar
                {...{
                    table,
                }}
            />
            {isSalesDataLoading ? (
                <Center w="100%" h="200px" bg="white" border="1px solid" borderColor="gray.100">
                    <Spinner />
                </Center>
            ) : (
                <>
                    <DITable table={table} isPagination isHeaderFixed />
                    <TablePagination table={table} />
                </>
            )}
        </Box>
    );
};

export default SalesDataTab;
